import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 140 140"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { transform: "matrix(10,0,0,10,0,0)" }, [
      _createElementVNode("g", null, [
        _createElementVNode("path", {
          d: "M2.25,5,6.74.61a.36.36,0,0,1,.52,0L11.75,5",
          style: {"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}
        }),
        _createElementVNode("path", {
          d: "M2.25,9l4.49,4.39a.36.36,0,0,0,.52,0L11.75,9",
          style: {"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }